import { useEffect, useState } from "react";
import configManager from "../../singleton/ConfigManager";
import configManagerEmitter from "../../utils/configManagerEmitter";
import { getAssetUploadCapacity } from "../../utils/runtime-settings";

export default function useAssetUploadCapacity() {
  const [capacity, setCapacity] = useState(() => getAssetUploadCapacity(configManager.config));

  useEffect(() => {
    const updateCapacity = () => setCapacity(getAssetUploadCapacity(configManager.config));
    configManagerEmitter.on("configUpdated", updateCapacity);
    updateCapacity();
    return () => configManagerEmitter.off("configUpdated", updateCapacity);
  }, []);

  return capacity;
}
